import { Request } from 'commons/utils/request'
import { InvoiceSubmittalEditMode } from '~bank-invoices/types/Manage'

export const getInvoiceSubmittalEditMode = (opts: { id: number }) =>
  Request.post<InvoiceSubmittalEditMode, { id: number }>(Request.urls.bank.invoiceSubmittalEditMode, opts)
